import React from 'react';
import { sectionsData } from '../data/sections.js';

const SideNav = ({ activeSection, scrollToSection }) => (
  <nav className="fixed top-0 left-0 h-screen w-14 sm:w-16 md:w-20 bg-brand-black z-50 flex flex-col items-center justify-between py-4 sm:py-6 md:py-8 overflow-y-auto">
      <button onClick={() => scrollToSection(sectionsData[0].id)} className="font-anton text-4xl shrink-0  transition-colors transition-transform  hover:scale-110" aria-label="Go to top">
      <img
    src="./assets/img/logo.png"
    alt="logo"
    className="w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 object-contain   " 
  />
      </button>
      
      <div className="flex flex-col items-center space-y-0.5 sm:space-y-1 md:space-y-0.5">
        {sectionsData.map((section, index) => (
          <button
            key={section.id}
            onClick={() => scrollToSection(section.id)}
            className={`font-bold text-sm sm:text-base md:text-xs transition-colors duration-300 p-1 sm:p-1.5 md:p-2 ${activeSection === section.id ? 'text-brand-red' : 'text-brand-cream/40 hover:text-brand-cream/80'}`}
            aria-label={`Go to section ${section.name}`}
          >
            {String(index + 1).padStart(2, '0')}
          </button>
        ))}
      </div>

      <a className="[writing-mode:vertical-rl] shrink-0 text-xs sm:text-sm uppercase tracking-widest cursor-pointer text-black hover:text-red-400 transition-colors bg-[#ffd299] p-1.5 sm:p-2 my-2" style={{ fontFamily: 'pinar' }}>
           هوش مصنوعی
            </a>
  </nav>
);

export default SideNav;
